const pages = {
  configurationSettingsList: {
    name: 'Configuration Settings',
    subpath: '',
    icon: '',
    component: () => import('../components/ConfigurationSettingsList'),
    meta: {
      breadcrumb: [{
        name: 'Configure Report Type',
      }],
    },
  },
  configurationSettingDetail: {
    name: 'Edit Configuration Setting',
    subpath: 'configuration-setting-detail',
    icon: '',
    component: () => import('../components/ConfigurationSettingDetail'),
    meta: {
      breadcrumb: [{
        name: 'Configure Report Type',
        link: 'configurationSettingsList',
      },
      {
        name: 'Configure Report Details',
      },
      ],
    },
  },
}
export default pages
